import errorSWWBg from '@assets/error-sww-bg.png';
import errorSWWIllustration from '@assets/error-sww-image.png';
import { ErrorPage } from '@components/ui/organisms/ErrorPage';

export const ConnectionErrorPage: React.FC = () => {
  // A real reload, not an error-boundary reset: resetting re-renders the same
  // failed state (e.g. a rejected lazy import), leaving the user stuck here.
  const handleReload = () => {
    window.location.reload();
  };

  return (
    <ErrorPage
      bgImage={errorSWWBg}
      illustration={errorSWWIllustration}
      title="Error!"
      subtitle="Something went wrong"
      description={`Something went wrong. Please check your internet connection or try refreshing the page. If the issue persists, feel free to reach out to us.`}
      errorCode="Connection Error"
      hideGoBack
      primaryAction={{
        label: 'Reload Page',
        onClick: handleReload,
      }}
    />
  );
};

ConnectionErrorPage.displayName = 'ConnectionErrorPage';
